import { Http } from '@angular/http';
import { Inject, Injectable } from '@angular/core';

import { ITenaFullFillmentScheduler } from '../../../../model/product/tena/tcw/ITenaFullFillmentScheduler';
import { ApiErrorHandler } from 'tridion.web.ui/src/app/angular/api/error/ApiErrorHandler';
import { ENVIRONMENT } from 'tridion.web.ui/src/app/angular/environment/ENVIRONMENT';
import { IEnvironment } from '../../../../environment/IEnvironment';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { BaseTCWApi } from './BaseTCWApi';
import { LiveStageService } from '../../../../environment/LiveStage.service';

@Injectable()
export class TenaFullFilmentSchedulerApi extends BaseTCWApi<ITenaFullFillmentScheduler> {
    constructor(
        apiErrorHandler: ApiErrorHandler,
        authService: AuthService,
        @Inject(ENVIRONMENT) environment: IEnvironment,
        http: Http,
        liveStageService: LiveStageService
    ) {
        super(apiErrorHandler, authService, environment, http, liveStageService);
    }

    protected getBaseUrl() {
        return this.TCWBaseURl + 'fulfillmentsscheduler/tena';
    }
}
